module.exports = __webpack_public_path__ + "static/StyreneA-Regular-e48d4edf0b0b7a89ea7ed97bc68d720d.eot";